import React from 'react';
import { Shield, Activity, Lock, Clock } from 'lucide-react';

const TrustBadges = ({ variant = 'row' }) => {
  const badges = [
    { icon: Activity, label: 'System Active', color: 'text-emerald-400', dot: true },
    { icon: Shield, label: 'Trading Engine Running', color: 'text-cyan-400' },
    { icon: Lock, label: 'Encrypted & Secure', color: 'text-blue-400' },
    { icon: Clock, label: 'Uptime 99.9%', color: 'text-slate-400' },
  ];

  if (variant === 'compact') {
    return (
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2" data-testid="trust-badges">
        {badges.map((b) => (
          <div key={b.label} className="flex items-center gap-1.5 text-xs text-slate-500">
            {b.dot && <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />}
            <b.icon className="w-3 h-3" />
            <span>{b.label}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="trust-badges">
      {badges.map((b) => (
        <div key={b.label} className="flex items-center gap-2.5 px-4 py-3 rounded-xl border border-white/[0.04] bg-white/[0.015]">
          {b.dot && <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse flex-shrink-0" />}
          <b.icon className={`w-4 h-4 ${b.color} flex-shrink-0`} />
          <span className="text-xs text-slate-400 font-medium">{b.label}</span>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;
